module.exports = __webpack_public_path__ + "img/pricing_hero_mobile.83a3735f.webp";